import React, {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Link, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import "./SendContract.css";
import SideCanvas from "./SideCanvas";
import TextEditorToSection from "./TextEditorToSection";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import SendToCustomerInfoModal from "./SendToCustomerInfoModal";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const SendContract = forwardRef((props, ref) => {
  // Reference for the SunEditor instance
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { eventID, documentId } = useParams();
  const editorRefs = useRef([]);
  let [contractCount, setContractCount] = useState(0);
  const [length, setlength] = useState(0);
  const title = useSelector((state) => state.title.title);
  const [contracttitle, setContracttitle] = useState("1");
  const [tabs, setTabs] = useState([]);
  const [selectedValue1, setSelectedValue1] = useState("");
  const [editorInstances, setEditorInstances] = useState({});

  const [usersignature, setUsersignature] = useState("");
  const [signaturebox, setsignaturebox] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [companylogo, setCompanylogo] = useState();
  const [secondarylogo, setSecondarylogo] = useState();
  const [phone, setPhone] = useState();
  const [email, setemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();

  const [EventData, setEventData] = useState({});

  // Function to handle checkbox change
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  //const { contractId } = useParams();
  const navigate = useNavigate();
  const [contract, setContract] = useState(null);
  const dispatch = useDispatch();

  const addsignature = () => {
    setUsersignature(signaturebox);
  };

  const handleChange = (event) => {
    setsignaturebox(event.target.value);
  };

  const handleSelectChange = (e) => {
    setSelectedValue1(e.target.value);
  };

  const getSunEditorInstance = (sunEditor, tabId) => {
    setEditorInstances((prev) => ({ ...prev, [tabId]: sunEditor }));
  };

  const handleInsertInputField = () => {
    const value = selectedValue1;
    if (!value) {
      Swal.fire({
        icon: "warning",
        title: "Select a field",
        text: "Please choose a smart text field first!",
      });
      return;
    }
    try {
      const activeTabId = document.querySelector(".tab-pane.active")?.id;
      if (!activeTabId) return;
      const editor = editorInstances[activeTabId];
      if (editor) {
        editor.core.focus();
        editor.insertHTML(value);
      }
    } catch (err) {
      console.error("[SUNEDITOR.insertHTML.fail]", err);
    }
  };

  const handleEditorChange = (content, tabId) => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.id === tabId ? { ...tab, content: content } : tab
      )
    );
  };

  const renamepage = (tabId) => {
    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) =>
          tab.id === tabId ? { ...tab, title: newTitle } : tab
        )
      );
    }
  };

  const handleClick = (id) => {
    setTabs((prevTabs) => prevTabs.filter((item) => item.id !== id));
  };

  const handleclone = (cloneid) => {
    //const clonetab = tabs.filter((item) => item.id === cloneid);
    const clonetab = tabs.filter((item) => item.id === cloneid);

    const newTabId = `v-pills-${contractCount + 2}`;
    const newTabContentId = `v-pills-content-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: clonetab[0].content,
    };
    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 2);
  };

  const addSmartTextPlugin = {
    name: "addSmartText",
    display: "command",
    title: "Add Smart Text",
    innerHTML: '<i class="fa fa-magic"></i>',
    buttonClass: "sun-editor-action customAction p-2",
    add: function () {},
    action: function () {
      try {
        const offcanvasEl = document.getElementById("offcanvasRightSmartText");
        if (offcanvasEl) {
          let bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
          if (!bsOffcanvas) {
            bsOffcanvas = new window.bootstrap.Offcanvas(offcanvasEl);
          }
          bsOffcanvas.show();
        }
      } catch (err) {
        console.error("SmartText action failed:", err);
      }
    },
  };

  useEffect(() => {
    // what should happen after the initial render
    const buttonid = `v-pills-${contractCount}-tab`;
    const activebutton = document.getElementById(buttonid);
    if (activebutton) {
      activebutton.click();
    }
    //active.setAttribute("data-scroll", <your_value>)
  }, [tabs.length]);

  const showPopup = () => {
    alert("Popup triggered!");
  };

  useEffect(() => {
    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(
          `/userdetaila/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );

        setCompanylogo(
          response.data.usersdetails[0].Main_Logo
            ? process.env.REACT_APP_BACKEND_URL +
                response.data.usersdetails[0].Main_Logo
            : null
        );

        setSecondarylogo(
          response.data.usersdetails[0].Secondary_Logo
            ? process.env.REACT_APP_BACKEND_URL +
                response.data.usersdetails[0].Secondary_Logo
            : null
        );

        setPhone(response.data.usersdetails[0].Phone_Number);
        setemail(response.data.usersdetails[0].Company_Email);
        setFname(response.data.usersdetails[0].first_name);
        setLname(response.data.usersdetails[0].last_name);
        setcompanyname(response.data.usersdetails[0].companyname);
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchuserdata();

    const fetchEventDetails = async () => {
      try {
        const response = await apiClient.get(`/event/${eventID}`);
        if (response.data.success === true) {
          setEventData(response.data.events);
        }
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };

    fetchEventDetails();
  }, []);

  //let c = contractCount;
  var count = 0;
  useEffect(() => {
    const fetchContract = async () => {
      try {
        const response = await apiClient.get(
          `/contracts/${documentId}`
        );

        setContract(response.data);
        count = 10;

        // setContractTitle(response.data.title);
        setContracttitle(response.data.title);

        const length = response.data.pages.length;

        const dynamicName = EventData.cl_firstname || "Default Name";

        response.data.pages.forEach((tabs1, index) => {
          //count++;
          const newTabTitle = tabs1.page_name;

          const newTabContent = tabs1.content
            .replace(/{Event_Name}/g, EventData.name || "Event Name")
            .replace(/{First_Client_First_Name}/g, EventData.cl_firstname || "")
            .replace(/{First_Client_Last_Name}/g, EventData.cl_lastname || "")
            .replace(/{First_Client_Email}/g, EventData.cl_email || "")
            .replace(/{Event_Location}/g, EventData?.address || "")
            .replace(/{Event_Date}/g, (() => {
              if (!EventData?.date) return "";
              const [year, month, day] = EventData.date.split("-");
              return month && day && year ? `${month}-${day}-${year}` : EventData.date;
            })())
            .replace(
              /{Event_Type}/g,
              EventData?.get_event_category?.name || ""
            );

          const newTab = {
            id: `v-pills-${index}`,
            title: newTabTitle,
            content: newTabContent,
          };
          setTabs((tabs) => [...tabs, newTab]);

          // Use functional update for setTabs to ensure latest state
        });

        const leftName = "Dhirendra";
        const rightName = "Jane Doe";

        const inputFieldHTML = `<input type="text" placeholder="" id='test' />`;

        if (editorRefs.current) {
          // alert("dhirendra");
          // Use the editor's execCommand to insert HTML at the cursor position
          // editorRefs.current.editor.core.context.element.wysiwyg.focus(); // Focus the editor first
          document.execCommand("insertHTML", false, inputFieldHTML); // Insert HTML

          // Optional: Trigger any additional actions
        } else {
          console.error("Editor instance is not available.");
        }

        dispatch(setTitle(response.data.title));

        setContractCount(response.data.pages.length - 1);
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };

    if (EventData.cl_firstname) {
      fetchContract();
    }
  }, [EventData.cl_firstname]);

  const handleEditorRef = (index, editor) => {
    if (editor) {
      editorRefs.current[index] = editor;
    }
  };

  // setContractCount(count);
  if (!contract) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async () => {
    try {
      await apiClient.put(
        `/contracts/${documentId}`,
        {
          title: title,
          pages: tabs.map((tab) => ({
            content: tab.content,
            page_name: tab.title,
          })),
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Contract updated successfully!",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
      });
      navigate("/contracts");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  };

  // Options for the SunEditor instance – upload images to server, store URL in content (not base64)
  const editorOptions = {
    ...getEditorUploadConfig(),
    height: 200,
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
        "addSmartText",
      ],
    ],
    plugins: [...allPlugins, addSmartTextPlugin],
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
      ],
    ],
  };

  // Function to handle adding a new contract page
  const handleAddContract = () => {
    const newTabId = `v-pills-${contractCount + 1}`;
    const buttonid = `v-pills-${contractCount + 1}-tab`;
    const newTabContentId = `v-pills-content-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: `<div>
        <h1>${newTabTitle}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
    };

    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 1);

    document.getElementById("offcanvasRight2").classList.remove("show");
    document.getElementById("offcanvasRight2").style.visibility = "hidden";
  };
  return (
    <>
      <SendToCustomerInfoModal
        type="Contract"
        id={documentId}
        title={title}
        contentpage=""
        details={tabs}
        usersignature={usersignature}
      />
      <div
        id="smarttextpopup"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRightSmartText"
        aria-controls="offcanvasRightSmartText"
        className="d-none"
      />
      {/* Smart Text canvas */}
      <div className="create-contract">
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasRightSmartText"
          aria-labelledby="offcanvasSmartTextLabel"
          data-bs-backdrop="false"
        >
          <div className="w-100 text-start header">
            <button
              type="button"
              className="btn-close mt-3 ms-4 text-black"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
            <div className="text-center py-3">
              <h5>Smart Text</h5>
            </div>
          </div>

          <div className="offcanvas-body p-4">
            <div className="single_box">
              <h6>Field content types: {selectedValue1}</h6>
              <select
                value={selectedValue1}
                onChange={handleSelectChange}
                style={{
                  width: "300px",
                  height: "40px",
                  outline: "none",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e8e4e4",
                }}
              >
                <option value="" disabled>
                  Select your option
                </option>
                <option value="{Event_Name}">Event Name</option>
                <option value="{First_Client_First_Name}">
                  First Client First Name
                </option>
                <option value="{First_Client_Last_Name}">
                  First Client Last Name
                </option>
                <option value="{First_Client_Email}">
                  First Client Email
                </option>
                <option value="{Event_Type}">Event Type</option>
              </select>
            </div>

            <div className="single_box mt-4">
              <button
                onClick={handleInsertInputField}
                style={{
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                  outline: "none",
                  backgroundColor: "#4f46e5",
                  border: "1px solid #e8e4e4",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Insert
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Side canvas for the smart text */}
      <SideCanvas
      // Pass the function to handle smart text input change
      />
      <div className="container-fluid p-lg-5 p-md-5 p-3">
        <div className="col-md-12 text-end mt-n1 mb-3"></div>
        <div className="row g-lg-5 row_mobile g-md-5 g-3 px-lg-5">
          {/* Text Editor part */}
          <div className="col-md-9">
            <div className="text-editor px-2 px-md-5 py-3">
              <div className="tab-content h-100" id="v-pills-tabContent">
                {/* text editor page */}
                {tabs.map((tab, index) => (
                  <div
                    key={tab.id}
                    className={
                      "tab-pane fade " +
                      (tab.id == "v-pills-home" ? "show active" : "")
                    }
                    id={tab.id}
                    role="tabpanel"
                    aria-labelledby={`${tab.id}-tab`}
                  >
                    {index == 0 ? <TextEditorToSection /> : ""}
                    <div className="position-relative overflow-hidden">
                      <SunEditor
                        setOptions={editorOptions}
                        defaultValue={tab.content}
                        onChange={(content) =>
                          handleEditorChange(content, tab.id)
                        }
                        getSunEditorInstance={(instance) =>
                          getSunEditorInstance(instance, tab.id)
                        }
                      />
                    </div>
                  </div>
                ))}

                <div
                  className={"tab-pane fade "}
                  id="sign"
                  role="tabpanel"
                  aria-labelledby={`sign-tab`}
                  style={{ background: "white", height: "100%" }}
                >
                  <div className="position-relative overflow-hidden">
                    <div className="signat">
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>

                      {usersignature == "" && (
                        <>
                          <div className="addbutton">
                            <button
                              className={`nav-link add_Signature`}
                              type="button"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#signpopup"
                              aria-controls="offcanvasRight"
                            >
                              Add Signature{" "}
                            </button>
                          </div>
                        </>
                      )}

                      {usersignature != "" && (
                        <>
                          <div className="signaturemain">{usersignature}</div>
                        </>
                      )}

                      <div className="sign_text">
                        {fname} {lname}{" "}
                      </div>
                      <div className="sign_text">{email}</div>

                      <div className="gap">
                        {" "}
                        <hr />{" "}
                      </div>

                      <div className="sign_text">
                        {EventData.cl_firstname} {EventData.cl_lastname}
                      </div>
                      <div className="sign_text">{EventData.cl_email}</div>
                    </div>
                  </div>
                </div>

                {/* add page */}
                <div
                  className="tab-pane fade h-100  text-center"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div className="add-page  d-flex flex-column justify-content-center align-items-center"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Contract Right Area */}
          <div className="col-md-3">
            <span className="placeholder col-6"></span>

            <div className="row">
              <div className="col-12">
                <div className="right-side-area">
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    {/* Current Page Start: Contract Box */}
                    {tabs.map((tab) => (
                      <button
                        key={tab.id}
                        className={`nav-link ${
                          tab.id === "v-pills-home" ? "active" : ""
                        }`}
                        id={`${tab.id}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#${tab.id}`}
                        type="button"
                        role="tab"
                        aria-controls={tab.id}
                        aria-selected={
                          tab.id === "v-pills-home" ? "true" : "false"
                        }
                      >
                        <div className="right-side-box">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div
                                className="icon-box active bg-white"
                                role="button"
                              >
                                <div className="row gap-2 align-items-start m-2">
                                  <div className="col-12 skeleton-one"></div>
                                  <div className="col-12 skeleton-two"></div>
                                  <div className="col-12 skeleton-three"></div>
                                  <div className="col-12 skeleton-four"></div>
                                </div>
                              </div>
                              <h5 className="box-title">{tab.title}</h5>
                            </div>
                            <div
                              className="nav-item dropdown"
                              id="top-user-nav"
                            >
                              <div
                                className="nav-link dropdown"
                                data-bs-toggle="dropdown"
                              >
                                <div className="three-dot-btn">
                                  <button
                                    className="border-0 bg-transparent"
                                    type="button"
                                  >
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                <Link to="#">
                                  <div
                                    className="link-btn mb-4 rename-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => renamepage(tab.id)}
                                  >
                                    <i
                                      className="fa fa-pencil"
                                      aria-hidden="true"
                                    ></i>
                                    <span>Rename</span>
                                  </div>
                                </Link>
                                <Link to="#">
                                  <div
                                    className="link-btn mb-4 duplicate-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => handleclone(tab.id)}
                                  >
                                    <i className="fa-solid fa-clone"></i>
                                    <span>Duplicate</span>
                                  </div>
                                </Link>
                                <Link to="#">
                                  <div
                                    className="link-btn text-danger delete-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => handleClick(tab.id)}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                    <span>Delete</span>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </button>
                    ))}

                    <button
                      key="signkey"
                      className="nav-link"
                      id={`sign-tab`}
                      data-bs-toggle="pill"
                      data-bs-target={`#sign`}
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      <div className="right-side-box">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div
                              className="icon-box active bg-white"
                              role="button"
                            >
                              <div className="row gap-2 align-items-start m-2">
                                <div className="col-12 skeleton-one"></div>
                                <div className="col-12 skeleton-two"></div>
                                <div className="col-12 skeleton-three"></div>
                                <div className="col-12 skeleton-four"></div>
                              </div>
                            </div>
                            <h5 className="box-title">Sign</h5>
                          </div>
                          <div className="nav-item dropdown" id="top-user-nav">
                            <div
                              className="nav-link dropdown"
                              data-bs-toggle="dropdown"
                            >
                              <div className="three-dot-btn">
                                <button
                                  className="border-0 bg-transparent"
                                  type="button"
                                >
                                  <i className="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                              </div>
                            </div>
                            <div className="dropdown-menu shadow-sm border-0 py-4 px-4"></div>
                          </div>
                        </div>
                      </div>
                    </button>

                    {/* Current Page End: Contract Box */}

                    {/* Add Page Start: New Page */}
                    <button
                      className="nav-link"
                      id="v-pills-profile-tab"
                      onClick={handleAddContract}
                      type="button"
                      role="tab"
                      aria-controls="v-pills-profile"
                      aria-selected="false"
                    >
                      {/* Add Page: New Page */}
                      <div className="right-side-box">
                        <div className="d-flex align-items-center justify-content-between">
                          <div
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight2"
                            aria-controls="offcanvasRight2"
                            className="d-flex align-items-center"
                          >
                            <div
                              className="icon-box icon-box-add-page"
                              role="button"
                            >
                              <span>
                                <i className="fa-solid fa-plus"></i>
                              </span>
                            </div>
                            Add
                          </div>
                          {/* Dropdown */}
                          <div
                            className="nav-item dropdown"
                            id="top-user-nav"
                            aria-disabled="true"
                          >
                            <div
                              href="#"
                              className="nav-link dropdown"
                              data-bs-toggle="dropdown"
                            >
                              {/*  <div className='three-dot-btn'>
                                <button className='border-0 bg-transparent pointer-event-none'>
                                  <i className='fa-solid fa-ellipsis-vertical'></i>
                                </button>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </button>
                    {/* Add Page End: New Page */}
                  </div>

                  <div className="text-center pt-2">
                    <button
                      id="submit-btn"
                      type="button"
                      className="px-5 rounded-pill btn btn-primary btn-lg text-uppercase"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal2"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                    >
                      Share
                    </button>
                  </div>

                  {/* Add page canvas */}
                  <div className="create-contract">
                    <div
                      className="offcanvas offcanvas-end"
                      tabindex="-1"
                      id="signpopup"
                      aria-labelledby="offcanvasRightLabel"
                      data-bs-backdrop="false"
                    >
                      <div className="w-100 text-start header">
                        <button
                          type="button"
                          className="btn-close mt-3 ms-4 text-black"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>

                        <div className="text-center py-3">
                          <h5>Signature</h5>
                          <span style={{ color: "#727272" }}>
                            Add Your Signature
                          </span>
                        </div>
                      </div>

                      <div className="offcanvas-body p-0">
                        <div className="single_box mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <input
                                type="text"
                                className="signbox"
                                onChange={handleChange}
                                value={signaturebox}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="single_box mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <input
                                type="checkbox"
                                onChange={handleCheckboxChange}
                              />{" "}
                              By clicking the button below, I,{" "}
                              <b>
                                {fname} {lname}{" "}
                              </b>
                              , confirm and consent to the use of my electronic
                              signature to sign this document. I acknowledge
                              that my electronic signature is legally binding,
                              just as if I had signed the document in person
                            </div>
                          </div>
                        </div>

                        <div className="single_box mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <button
                                type="button"
                                className="mt-3 ms-4 text-black backbackground add_Signature"
                                data-bs-dismiss="offcanvas"
                                disabled={!isChecked}
                                onClick={addsignature}
                                aria-label="Close"
                              >
                                SIGN
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="offcanvas offcanvas-end"
                      tabindex="-1"
                      id="offcanvasRight2"
                      aria-labelledby="offcanvasRightLabel"
                      data-bs-backdrop="false"
                    >
                      <div className="w-100 text-start header">
                        <button
                          type="button"
                          className="btn-close mt-3 ms-4 text-black"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>

                        <div className="text-center py-3">
                          <h5>Add Page</h5>
                          <span style={{ color: "#727272" }}>
                            Select from the list below
                          </span>
                        </div>
                      </div>
                      <div className="w-100 text-start header">
                        <div
                          className="text-center py-3 single_box"
                          onClick={handleAddContract}
                        >
                          <span>+ Page With Text Only</span>
                        </div>
                      </div>

                      <div className="offcanvas-body p-0">
                        <h5 className="px-4 py-2">Contracts</h5>

                        <div className="single_box mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div onClick={handleAddContract}>
                              <h6>New Contract</h6>
                              <div className="d-flex align-items-center mt-1">
                                <i className="far fa-folder"></i>
                                <span className="ms-2">Contract</span>
                              </div>
                            </div>
                            <div className="icon">
                              <i className="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>

                        <div className="single_box mt-4">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h6>Basic Booth Contract</h6>
                              <div className="d-flex align-items-center mt-1">
                                <i className="far fa-folder"></i>
                                <span className="ms-2">Contract</span>
                              </div>
                            </div>
                            <div className="icon">
                              <i className="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>

                        <div>
                          <h5 className="py-4 px-4">Invoice</h5>
                          <div className="single_box mt-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h6>New Invoice</h6>
                                <div className="d-flex align-items-center mt-1">
                                  <i className="far fa-folder"></i>
                                  <span className="ms-2">Invoice</span>
                                </div>
                              </div>
                              <div className="icon">
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </div>
                          <div className="single_box mt-4">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h6>Click Firefly - 2 Hour Invoice</h6>
                                <div className="d-flex align-items-center mt-1">
                                  <i className="far fa-folder"></i>
                                  <span className="ms-2">Invoice</span>
                                </div>
                              </div>
                              <div className="icon">
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
export default SendContract;
